<script setup lang="ts">
import { watch } from 'vue';

import { useCountdown } from '@/composables/carts/useCountdown';

const props = defineProps<{
  utcExpiresAt: string | null;
}>();

const emit = defineEmits<{
  expired: [];
}>();

const { formattedTime, isExpired } = useCountdown(() => props.utcExpiresAt);

watch(isExpired, (expired) => {
  if (expired) {
    emit('expired');
  }
});
</script>

<template>
  <span v-if="utcExpiresAt && !isExpired" class="expiration-badge">
    {{ $t('cart.details.bookingGuaranteed') }} {{ formattedTime }}
  </span>
</template>

<style scoped lang="css">
.expiration-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  background: #e5f1fc;
  color: #005cb2;
  border-radius: var(--yb-radius-xs);
  font-size: var(--yb-text-sm);
  font-weight: var(--yb-text-semi-bold);
  white-space: nowrap;
}
</style>
